import getAxiosClient from "@lib/getAxiosClient";
import { ConfigurationItemPayload } from "@sourceful/shared-types";
import { apiConfig } from "../../../apiConfig";
import { isGuestConfigItem } from "@sourceful/shared-utils/configuration-utils";

interface UpdateConfigItemRecordArgs {
  token: string;
  payload: ConfigurationItemPayload;
  basketId: string | undefined;
}

export const updateConfigItemRecord = async ({
  token,
  payload,
  basketId,
}: UpdateConfigItemRecordArgs) => {
  if (isGuestConfigItem(payload.id.toString())) {
    throw new Error(`Error attempting to sync guest config item: ${payload.id}`);
  }

  const client = getAxiosClient(token, {
    baseURL: apiConfig.productCloudApiOrigin,
  });

  const res = await client.put("/configuration-item", {
    item: payload,
    basketId,
  });

  return res?.data;
};
